import React from "react";
import {graphql} from "gatsby";


import SEO from "../components/seo";
import SectionWrapper from "../components/SectionWrapper/SectionWrapper";
import Header from '../components/Header/Header';

import mainvideo from '../assets/video/wesele promo_2_1.mp4';

const titleText = "Wszystko czego potrzebujesz na wesele";

const paragraphText = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem, debitis nisi! Illo, molestiae veniam! Qui, ut dolorem! Modi vitae voluptatum aliquam nemo eaque tempore, inventore, cum eum facilis aspernatur amet vero labore culpa corrupti reiciendis qui!";

const IndexPage = ({data}) => {
  const oprawa = data.oprawa.childImageSharp.fluid;
  const naglosnienie = data.naglosnienie.childImageSharp.fluid;
  const konferansjerzy = data.konferansjerzy.childImageSharp.fluid;
  const dodatkowe = data.Dodatkowe.childImageSharp.fluid;
  
  const content = [
    {
      title: "Oprawa muzyczna wesel",
      text: "Wyjątkowy dzień potrzebuje wyjątkowej muzyki. Zapewniamy kompleksową obsługę techniczną i muzyczną. Do Państwa dyspozycji : Dj-e ,instrumentaliści, wokaliści oraz najlepsze weselne zespoły. Zapewniamy najwyższą jakośc muzyczną oraz kompleksową obsługę techniczną i logistyczną.",
      image: oprawa,
      alt: "Oprawa muzyczna wesel",
      link: "/muzycznaobslugawesel",
    },
    {
      title: "Nagłośnienie i oświetlenie", 
      text: "W naszej ofercie znajduje się pełne nagłośnienie zarówno dla dużych zespołów jak i  pojedynczych instrumentalistów i Dj’ów. Nasi profesjonalni techniczni zapewnią profesjonalną obsługę na wesele i przygotują opasowaną do miejsca oprawę dźwiękową i świetlną. Dysponujemy własnym pełnym, profesjonalnym zapleczem techniki scenicznej z      obsługą profesjonalsitów, którzy na codzień pracują dla gwiazd polskiej estrady.",
      image: naglosnienie,
      alt: "Nagłośnienie i oświetlenie",
      link: "/naglosnienie"
    },
    {
      title: "Konferansjerzy i prowadzący", 
      text: "Udane wesele to impreza prowadzona przez odpowiedniego wodzireja. Gry, zabawy oraz pięknie przedstawienie ważnych gości to konieczny element podczas najważniejszej uroczystośći w Twoim życiu. Poznaj naszych profejonalnych konferansjerów na wesele i zapytaj o dostepność jednego z nich.",
      image: konferansjerzy,
      alt: "Konferansjerzy i prowadzący",
      link: "/prowadzacy"
    },
    {
      title: "Usługi dodatkowe", text: "Sprostamy najbardziej wyszukanym oczekiwaniom Państwa młodych. W ramach usług dodatkowych na wesele, jesteśmy w stanie zapewnić dla Państwa weselny show pięknych skrzypaczek, pokazy magii, show oświetleniowe, nietuzinkowe pokazy barmańskie z udziałem mistrzów świata, obsługę fotografa czy obsługę dekoratora i forystki!",
      image: dodatkowe,
      alt: "Usługi dodatkowe",
      link: "uslugidodatkowe"
    },
    
  ];


  return (
  <>
    <SEO title="Oprawa muzyczna wesel"/>
    <Header video link={mainvideo}/>
    <SectionWrapper content={content} title={titleText} text={paragraphText} fourItems={true} resize="yes"/>
  </>
)}

export const query = graphql`
  {
    oprawa: file(name: {eq: "Oprawa"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG

        }
      }
    }
    naglosnienie: file(name: {eq: "Naglosnienie"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    konferansjerzy: file(name: {eq: "Konferansjerzy"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    Dodatkowe: file(name: {eq: "Dodatkowe"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

export default IndexPage
